import { INode } from 'shared/types/tree'
import { Box } from '@mui/material'
import { AttributionEdit, GradeEdit, SubjectEdit } from './LeafView'
import * as React from 'react'

export function EditableCurriculaTree({ tree }: { tree: INode }) {
  return (
    <Box padding="10px">
      <Box>
        <strong>Tree Attributes</strong> changing these actually updates the
        tree, the page will reload with the new value.
      </Box>
      <Box padding="10px" display="flex" flexDirection="row">
        <Box>
          <Box>
            <strong>Partner:</strong>
          </Box>
          <AttributionEdit parentNode={tree} />
        </Box>
        <Box>
          <Box>
            <strong>Grade:</strong>
          </Box>
          <GradeEdit parentNode={tree} />
        </Box>
        <Box>
          <Box>
            <strong>Subject:</strong>
          </Box>
          <SubjectEdit parentNode={tree} />
        </Box>
      </Box>
    </Box>
  )
}
